import coverImgEn from "assets/images/v113/cover-en.webp"
import coverImgFr from "assets/images/v113/cover-fr.webp"
import coverImgEs from "assets/images/v113/cover-es.webp"
import coverImgDe from "assets/images/v113/cover-de.webp"
import coverImgIt from "assets/images/v113/cover-it.webp"

export const v113Config = {
  cover: {
    en: coverImgEn,
    fr: coverImgFr,
    es: coverImgEs,
    de: coverImgDe,
    it: coverImgIt,
  },
}
